const TableRow = theme => ({
    root: {
        '&:nth-child(even)': {
            backgroundColor: theme.palette.grey[100],
        }
    }
})

export default TableRow;